/**
 * 店舗一覧のモーダル要素
 */
export default function shopListModal() {
  (function ($) {
    // 雑貨ページでなければ処理をしない
    if (!$('body').hasClass('page-template-zakka')) return;

    // モーダルを開く
    $('.p-zakka-shop-list__item').on('click', function () {
      var shopId = $(this).data('shop-id');
      $('#shop-list-modal-' + shopId).addClass('js-is-show');
    });

    // モーダルを閉じる
    $('.p-zakka-shop-modal__close').on('click', function () {
      var shopId = $(this).data('shop-id');
      $('#shop-list-modal-' + shopId).removeClass('js-is-show');
    });

    $('.p-zakka-shop-modal__box-close').on('click', function () {
      var shopId = $(this).data('shop-id');
      $('#shop-list-modal-' + shopId).removeClass('js-is-show');
    });
  })(jQuery);
}
